import * as React from 'react';
import styled from 'styled-components';
import { Button } from './Button';
import { ButtonSize, ButtonType } from '../../enums/common';
import { Icon } from '../icon/Icon';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SOnlineButton = styled(Button)<{ secondary: boolean; disabled: boolean; margin: string }>(
  ({ theme, disabled, margin, secondary }) => `
    font-family: 'Poppins';
    width: auto;
    max-width: 98%;
    height: 40px;
    border-radius: 35.5px;
    box-shadow: ${disabled ? 'none' : '5.7px 5.7px 13px 0 rgba(0, 0, 0, 0.16)'};
    margin: ${margin || '30px auto'};
    padding: 0 30px;

    ${
      disabled
        ? `
        background-color: ${theme.colors.disabledBG};
        pointer-events: none;
      `
        : `
        background-color: ${secondary ? theme.colors.white : theme.colors.primaryBright};
        @media only screen and (min-width: 800px) {
            &:hover {
              background: ${
                secondary
                  ? `linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), ${theme.colors.white}`
                  : `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), ${theme.colors.primaryBright}`
              };
                &:before {
                  opacity: 0;
                }
              }
          }
      `
    }
    @media only screen and ${theme.device.max.laptopS} {
      height: 40px;
      border-radius: 31.1px;
      box-shadow: 4.8px 6.4px 13px 0 rgba(0, 0, 0, 0.16);
    }

    > .btn-icon {
      display: flex;
      margin-right: 10px;
      filter: ${secondary ? 'brightness(1)' : 'brightness(100)'}
    }

    > .text {
        display: flex;
        align-items: center;
        font-size: ${theme.font.size.smallMedium};
        line-height: 1.81;
        letter-spacing: 1.05px;
        color: ${secondary ? theme.colors.primaryBright : theme.colors.white};
        font-family: Poppins;

        ${
          disabled &&
          `
          font-family: 'Poppins';
          color: ${theme.colors.disabledText};
          font-weight: 800;
        `
        };

        @media only screen and ${theme.device.max.laptopS} {
          font-size: 15px;
        }

        @media only screen and ${theme.device.max.mobileM} {
          font-size: ${theme.font.size.small};
        }
    }
`
);

export interface OnlineButtonProps {
  submit: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  dataAt?: string;
  dataTestId?: string;
  dataDdAction?: string;
  id?: string;
  buttonText: string;
  disabled?: boolean;
  margin?: string;
  secondary?: boolean;
  size?: ButtonSize;
  icon?: string;
  className?: string;
  type?: ButtonType;
  stretch?: boolean;
}

export default ({
  className,
  submit: onClick,
  buttonText,
  disabled,
  dataAt,
  id,
  margin,
  secondary,
  size,
  icon,
  dataTestId,
  type,
  stretch,
  dataDdAction,
}: OnlineButtonProps) => {
  return (
    <SOnlineButton
      {...{
        className,
        margin,
        disabled,
        dataAt,
        id,
        secondary,
        onClick,
        size,
        dataTestId,
        type,
        stretch,
        dataDdAction,
      }}
    >
      {icon ? <Icon className="btn-icon" src={icon} /> : null}
      <span className="text"> {buttonText}</span>
    </SOnlineButton>
  );
};
